module.exports = __webpack_public_path__ + "img/41.7c69a910.png";